import { IManagingWebSitesInstance } from '../../api/models';
import { AppEnvironment } from '../../constants/AppEnvironment';
import { WebSiteState } from '../../constants/WebSiteState';
import { IStyledText, StyledText } from '../UIExtentions/Text';

function GetStateProps(state: string, environment: AppEnvironment): IStyledText {
    switch (state) {
        case WebSiteState.Started:
            return {
                text: 'Started',
                className: 'text-success',
            };
        case WebSiteState.Stopped:
            return {
                text: 'Stopped',
                className: environment === AppEnvironment.Production ? 'text-danger' : null,
            };
        default:
            return {
                text: state,
            };
    }
}

export default function WebSitesState(serverApp: IManagingWebSitesInstance) {
    const stateProps = GetStateProps(serverApp.state, serverApp.environment as AppEnvironment);
    return <StyledText {...stateProps} />;
}
